import React, { Component } from 'react'
import { Modal } from 'antd'
import './index.less'
class TipsDialog extends Component{
    constructor(props){
        super(props)
        this.state = {
            visible: this.props.visible
        }
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    handleCloseModal(){
        this.setState({
            visible: false
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        this.setState({
            visible: nextProps.visible
        })
    }

    render(){
        const { visible } = this.state
        return <>
            <Modal title="敦煌网商户注册协议和隐私政策" style ={{borderRadius:"25px",overflow:"auto"}} width='550px' visible={visible} onOk={this.handleCloseModal} onCancel={this.handleCloseModal} footer={[
                <button className='register-modal-confirmbtn' onClick={this.handleCloseModal}>同意并继续</button>
            ]}>
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
            </Modal>
        </>
    }
}

export default TipsDialog